(() => {
  const revealClass = 'mouse-scroll-reveal';
  const visibleClass = 'is-visible';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observer = 'IntersectionObserver' in window && !reducedMotion.matches
    ? new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add(visibleClass);
          currentObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.12
      })
    : null;

  const addReveal = (element, delay = 0) => {
    if (!element || element.classList.contains(revealClass)) return;

    element.classList.add(revealClass);
    element.style.setProperty('--mouse-reveal-delay', `${delay}ms`);

    if (observer) {
      observer.observe(element);
    } else {
      element.classList.add(visibleClass);
    }
  };

  const addAll = (root, selector, stagger = 0, startDelay = 0) => {
    root.querySelectorAll(selector).forEach((element, index) => {
      addReveal(element, startDelay + (index * stagger));
    });
  };

  const prepareMouseSections = (scope = document) => {
    addAll(scope, '.mouse-feature-collage__foreground');

    addAll(scope, '.mouse-competitive-intro__copy');
    addAll(scope, '.mouse-competitive-intro__card', 0, 120);
    addAll(scope, '.mouse-clicks-comparison__copy');

    addAll(scope, '.mouse-click-customization__header');
    scope.querySelectorAll('.mouse-click-customization__feature').forEach((feature) => {
      addReveal(feature.querySelector('.mouse-click-customization__copy'));
      addReveal(feature.querySelector('.mouse-click-customization__media'), 100);
    });

    addAll(scope, '.mouse-ready-modes__heading');
    addAll(scope, '.mouse-hand-design__heading');
    addAll(scope, '.mouse-hand-design__spec--weight', 0, 80);
    addAll(scope, '.mouse-hand-design__spec--shape', 0, 160);
    addAll(scope, '.mouse-click-feel__heading');
    addAll(scope, '.mouse-battery__content');
    addAll(scope, '.mouse-dual-connectivity__content');
    addAll(scope, '.mouse-competitive-players__content');

    addAll(scope, '.mouse-purchase-footer__main');
    addAll(scope, '.mouse-purchase-footer__divider', 0, 100);
    addAll(scope, '.mouse-purchase-footer__service', 110, 140);

    addAll(scope, '.mouse-box-parameters__heading');
    addAll(scope, '.mouse-box-parameters__item', 80, 80);
    addAll(scope, '.mouse-box-parameters__parameter-row');
    addAll(scope, '.mouse-box-parameters__parameter-group', 90);
    addAll(scope, '.mouse-box-parameters__notes');
  };

  const initialize = () => {
    document.documentElement.classList.add('mouse-scroll-reveal-ready');
    prepareMouseSections();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepareMouseSections(event.target);
  });
})();
